import PropTypes from 'prop-types'
import React from 'react'
import { getOauthClient, getToken } from 'utils'
import { Route } from 'react-router-dom'

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      getToken()
      ? <Component {...props} />
      : handleNotAuthenticated(Object.values(rest.location).join(''))
    }
  />
)

PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
  match: PropTypes.object,
}

const handleNotAuthenticated = path => {
  const OAuth = getOauthClient(path)
  window.location.href = OAuth.token.getUri()
  return null
}

export default PrivateRoute
